import { render, staticRenderFns } from "./CreateReviewForm.vue?vue&type=template&id=b83fc2b2&"
import script from "./CreateReviewForm.vue?vue&type=script&lang=js&"
export * from "./CreateReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports